import {
    createStore
} from "redux";

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

let initialState = {
    scrollPosition: 0,
    posts: [],
    navbarState: {
        notification: false,
        home: true,
        search: false,
        post: false,
        chat: false,
        profile: false,
    },
    commmentIndicator: false,
    commentIndicatorName: "",
    commentParentID: "",
    cropModal: false,

    notification: {
        isEnabled: false,
        text: '',
        icon: ''
    },

    userState: {
        balance: 0,
        bio: "Hey there, I am using Lovrapp",
        email: "",
        followersCount: 0,
        followingCount: 0,
        id: "",
        image: "",
        socialMedia: {
            'twitter': "",
            'instagram': "",
            'twitch': "",
            'spotify': "",
            'tiktok': "",
            'website': "",
            'snapchat': "",
            'pornhub': ""
        },
        isCreator: "",
        location: "",
        name: "",
        price: "0",
        sex: "",
        tags: [],
        username: "",
    },


    settingState: {
        pushNewComments: false,
        pushNewLikes: true,
        pushNewSubscribers: false,
        pushNewTip: false,
        pushNewMessage: true,
        pushNotifications: true,
        emailNewComments: false,
        emailNewLikes: true,
        emailNewSubscribers: false,
        emailNewTip: false,
        emailNewMessage: true,
        emailNotifications: true,
    },
    
    lightTheme: {
        "bgColor": "#F1F3F6",
        "bg2Color": "#FFFFFF",
        "activeColor": "#CA3443",
        "greenColor": "#01B27A",
        "colorText": "#BBBDC0",
    },
    darkTheme: {
        "bgColor": "#212426",
        "bg2Color": "#2D3134",
        "activeColor": "#CA3443",
        "greenColor": "#01B27A",
        "colorText": "#BBBDC0",
    },
    activeTheme: {
        "bgColor": "#212426",
        "bg2Color": "#2D3134",
        "activeColor": "#CA3443",
        "greenColor": "#01B27A",
        "colorText": "#BBBDC0",
    },
    isDark: true,
    isLoggedIn: false,
};

function reducer(state, {
    type,
    payload
}) {
    switch (type) {
        case "UPDATE_NAV":
            return {
                ...state,
                navbarState: payload
            }
            
        case "ADD_POST":
            return {
                ...state,
                posts: [...payload]
            };
        case "ADD_IMAGE_POST":
            return {
                ...state,
                imagePosts: [...payload]
            }
        case "ADD_VIDEO_POST":
            return {
                ...state,
                videoPosts: [...payload]
            }
        case 'ADD_BM_POST':
            return{
                ...state,
                bmPosts: [...payload]
            }
        case "EMPTY_POST":
            return {
                ...state,
                posts: []
            }
        case "EMPTY_IMAGE_POST":
            return {
                ...state,
                imagePosts: []
            }

        case "EMPTY_VIDEO_POST":
            return {
                ...state,
                videoPosts: []
            }
        case "EMPTY_BM_POST":
            return {
                ...state,
                bmPosts: []
            }
        case 'TOGGLE_CROP_MODAL':
            return {
                ...state,
                cropModal: !state.cropModal
            }
        case "TOGGLE_THEME":
            if (state.isDark) {
                state.activeTheme = state.lightTheme
            } else state.activeTheme = state.darkTheme
            return {
                ...state,
                isDark: !state.isDark
            };
        
        case "SET_COMMENT_INDICATOR":
            return{
                ...state,
                commmentIndicator: payload
            }
        case 'SET_COMMENT_PARENT_ID':
            return{
                ...state,
                commentParentID: payload
            }
        case 'SET_C_I_NAME':
            return {
                ...state,
                commentIndicatorName: payload
            }
        case "HIDE_NAVBAR":
           if(document.body.clientWidth < 750){
               document.getElementById('desktopNav').style.display = "none";
           }
           return {
                ...state
            };

        case "SHOW_NAVBAR":
            if(document.body.clientWidth < 750){
                document.getElementById('desktopNav').style.display = "flex";
            }
            return {
                ...state
            };

        case "UPDATE_USER_DATA":
            return {
                ...state,
                userState: payload,
            };
        
        case "TOOGLE_LOGGEDIN":
            if(state.isLoggedIn){
            }
            return {
                ...state,
                isLoggedIn: !state.isLoggedIn,
            }
        case "PUSH_SETTINGS":
            return{
                ...state,
                settingState: payload,
            }
        case 'SET_NOTIFICATION':
            return{
                ...state,
                notification: payload
            }
        case "SET_SCROLL_POSITION":
            return{
                ...state,
                scrollPosition: payload,
            }
        default:
            return {
                ...state
            };
    }
}

const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, reducer)
const store = createStore(persistedReducer, initialState,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
const persistor = persistStore(store)


export  {persistor, store}